import { useEffect, useState } from "react";
import SideNavLayout from "../../customsidenav/sidenavlayout";
import TimesheetFilterButtons from "../utils/timesheetbuttons";
import TimesheetSearchBar from "../utils/timesheetfilters";
import TimesheetEmployeeTypeButtons from "../utils/timesheettypebuttons";
import TimesheetTable from "../utils/timesheettable";
import ManualEntry from "./manualentry";
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import { backicon, filterlinkicon } from "../utils/svg";

import RecapTable from "../utils/recaptable";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTableCells,
  faCalendarDays,
} from "@fortawesome/free-solid-svg-icons";
import { PTORequestsTable } from "../pto/tableView";
import { PTOCalendarPro } from "../pto/calendarView";
import { Backdrop, CircularProgress } from "@mui/material";
import api from "../../api/api";
import { set } from "date-fns";
import dayjs from "dayjs";
import ToastMessage from "../../utils/mui/righttoptoast";
import { useSelector } from "react-redux";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { el } from "date-fns/locale";
import { getPracticeId, practiceShortName } from "../../config/practice";
dayjs.extend(utc);
dayjs.extend(timezone);
const EmployeeTimesheets = () => {
  const [selected, setSelected] = useState("All");
  const [timesheets, setTimesheets] = useState([]);
  const [ptoview, setPtoView] = useState(0);
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState(0);
  const [dateRange, setDateRange] = useState({
    startDate: dayjs(),
    endDate: dayjs(),
  });
  const [selectedemptype, setSelectedemptype] = useState("All Employees");
  const practiseid = getPracticeId();
  const [timesheetData, setTimesheetData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [recapData, setRecapData] = useState([]);
  const [isNewApp, setIsNewApp] = useState(true);
const [showFilterModal, setShowFilterModal] = useState(false);
const [selectedEmployees, setSelectedEmployees] = useState([]); 
  const user = useSelector((state) => state.userconfig);
  const buttons =
    type === 2
      ? [
          { label: "All" },
          { label: "Pending" },
          { label: "Approved" },
          { label: "Denied" },
        ]
      : type === 0
        ? [
            { label: "All" },
            { label: "Pending" },
            { label: "Submitted" },
            { label: "Deleted" },
            { label: "Auto Clockout" }, // 👈 only here           
          ]
        : [
            { label: "All" },
            { label: "Pending" },
            { label: "Submitted" },
            { label: "Deleted" },
          ];

  //filter states
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredTimesheetData, setFilteredTimesheetData] = useState([]);
  const [filteredRecap, setFilteredRecap] = useState([]);
  const [ptoreq, setPtoReq] = useState([]);
  const [filteredptoreq, setFilteredPtoReq] = useState([]);
  const [open, setOpen] = useState(false);
  const [severity, setSeverity] = useState("info");
  const [alertmessage, setAlertMessage] = useState("");
  const [apiloadings, setApiLodings] = useState(false);
  const [openManualEntryModal, setOpenManualEntryModal] = useState(false);
  const handlealert = () => setOpen(false);
  const getWeekRange = (date = dayjs()) => {
    const start = date.startOf("week").add(1, "day"); // Monday
    const end = start.add(6, "day"); // Sunday
    return { startDate: start, endDate: end };
  };

  const getLastTwoWeeksRange = () => {
    // const end = dayjs().endOf("week"); // Sunday
    // const start = end.subtract(13, "day"); // 14 days total
      const start = dayjs();
      const end = dayjs();
    return { startDate: start, endDate: end };
  };
  // const fetchtimesheetdata = async ({ start_date, end_date, status } = {}) => {
  //   try {
  //     setLoading(true);

  //     // Fallback to state values if params not provided
  //     const startDate = start_date || dateRange.startDate.format("YYYY-MM-DD");
  //     const endDate = end_date || dateRange.endDate.format("YYYY-MM-DD");
  //     let params = {
  //       start_date: startDate,
  //       end_date: endDate,
  //     };
  //     if (status || (selected !== "All" && selected !== "Auto Clockout")) {
  //       params.status = status || selected;
  //     }
  //     const response = await api.get(`/v1/${practiseid}/timesheet/all`, {
  //       params,
  //     });

  //     if (response.status === 200) {
  //       let data = [];

  //       if (Array.isArray(response?.data)) {
  //         if (isNewApp) {
  //           // 👉 Ignore conversion for new app
  //           data = response.data;
  //         } else {
  //           // 👉 Convert time for old app
  //           data = response.data.map((obj) => {
  //             const convert = (dt) => {
  //               if (!dt) return dt;
  //               return dayjs
  //                 .utc(dt)
  //                 .tz("America/Regina")
  //                 .format("YYYY-MM-DDTHH:mm:ss");
  //             };

  //             return {
  //               ...obj,
  //               clock_in_time: convert(obj.clock_in_time),
  //               clock_out_time: convert(obj.clock_out_time),
  //             };
  //           });
  //         }
  //       }

  //       setTimesheetData(data);
  //     } else {
  //       setTimesheetData([]);
  //     }
  //   } catch (error) {
  //     console.log("Error fetching timesheet:", error);
  //     setTimesheetData([]);
  //   } finally {
  //     setLoading(false);
  //   }
  // };


  useEffect(() => {
    document.title = `${practiceShortName()} - Employee Attendance`;
  if (type !== 0) return;
  if (!timesheetData || timesheetData.length === 0) {
    setFilteredTimesheetData([]);
    return;
  }

  let filtered = [...timesheetData];

  // 🔴 Auto Clockout filter
  if (selected === "Auto Clockout") {
    filtered = filtered.filter((item) => {
      const auditLogs = item.audit_logs ? JSON.parse(item.audit_logs) : {};
      return auditLogs.autoClockout?.toUpperCase() === "Y";
    });
  }

  // 🔍 Search filter
  if (searchTerm.trim() !== "") {
    const lowerSearch = searchTerm.toLowerCase();
    filtered = filtered.filter(
      (item) =>
        (item.emp_name ?? "").toLowerCase().includes(lowerSearch) ||
        (item.emp_role ?? "").toLowerCase().includes(lowerSearch) ||
        (item.firstname ?? "").toLowerCase().includes(lowerSearch) ||
        (item.lastname ?? "").toLowerCase().includes(lowerSearch),
    );
  }

  // 👷 Employee type filter
  if (selectedemptype !== "All Employees") {
    const empType = selectedemptype.replace(" Employees", "");
    filtered = filtered.filter((item) =>
      item.employee_type?.toLowerCase().includes(empType.toLowerCase())
    );
  }

  // ✅ Employee name filter (from modal)
  if (selectedEmployees.length > 0) {
    filtered = filtered.filter((item) =>
      selectedEmployees.includes(
        `${item.firstname || ""} ${item.lastname || ""}`.trim()
      )
    );
  }

  setFilteredTimesheetData(filtered);
}, [timesheetData, selected, searchTerm, selectedemptype, type, selectedEmployees]);

  const fetchtimesheetdata = async ({ start_date, end_date, status } = {}) => {
  try {
    setLoading(true);

    // Fallback to state values if params not provided
    const startDate = start_date || dateRange.startDate.format("YYYY-MM-DD");
    const endDate = end_date || dateRange.endDate.format("YYYY-MM-DD");
    
    // Set up params for the API request
    let params = {
      start_date: startDate,
      end_date: endDate,
    };

    // Add status if provided or based on selected
    if (status || (selected !== "All" && selected !== "Auto Clockout")) {
      params.status = status || selected;
    }

    // Declare response variables
    let response = [];
    let absentResponse = null;
    let allResponse = null;

    // Fetch data based on the selected value
    if (selected === "All" || selected === "") {
      // absentResponse = await api.get(`/v1/${practiseid}/timesheet/absent`, { params });
      allResponse = await api.get(`/v1/${practiseid}/timesheet/all_periods`, { params });
    } else if (selected === "Absent") {
      absentResponse = await api.get(`/v1/${practiseid}/timesheet/absent`, { params });
    } else {
      allResponse = await api.get(`/v1/${practiseid}/timesheet/all_periods`, { params });
    }
    // console.log("API Responses:", { absentResponse, allResponse });
    // Check if responses are valid and have status 200
    if ((selected === "All" || selected === "") && (absentResponse && absentResponse.status === 200) || (allResponse && allResponse.status === 200)) {
      // response = [...allResponse.data, ...absentResponse.data];  // Combine both data
        response = [
          ...(allResponse?.data || []),
          ...(absentResponse?.data || [])
        ];
    } else if (selected === "Absent" && absentResponse && absentResponse.status === 200) {
      response = absentResponse.data;
    } else if (selected !== "Absent" && selected !== "All" && allResponse && allResponse.status === 200) {
      response = allResponse.data;
    } else {
      throw new Error("Failed to fetch valid data for the selected option");
    }

    // Further processing on the response
    if (Array.isArray(response)) {
      let data = response; 

      // If the app is a new version, skip time conversion
      if (isNewApp) {
        data = response;  // No conversion needed for new app
      } else {
        // 👉 Convert time for old app
        data = response.map((obj) => {
          const convert = (dt) => {
            if (!dt) return dt;  // If no date is provided, return the value as is
            return dayjs.utc(dt).tz("America/Regina").format("YYYY-MM-DDTHH:mm:ss");
          };

          return {
            ...obj,
            clock_in_time: convert(obj.clock_in_time),
            clock_out_time: convert(obj.clock_out_time),
          };
        });
      }

      // Set the processed timesheet data
      setTimesheetData(data);
    } else {
      setTimesheetData([]); // If the response is not an array, reset timesheet data
    }
  } catch (error) {
    console.log("Error fetching timesheet:", error);
    setTimesheetData([]); // Set empty data on error
  } finally {
    setLoading(false); // Always stop the loading spinner
  }
};

  const fetchrecapdata = async ({ start_date, end_date, status } = {}) => {
    try {
      setLoading(true);

      // Fallback to state values if params not provided
      const startDate = start_date || dateRange.startDate.format("YYYY-MM-DD");
      const endDate = end_date || dateRange.endDate.format("YYYY-MM-DD");
      let params = {
        start_date: startDate,
        end_date: endDate,
      };
      const finalStatus = status || selected;

      if (finalStatus && finalStatus !== "All") {
        params.status = finalStatus;
      }
      const response = await api.get(`/v1/${practiseid}/timesheet/recap`, {
        params,
      });

      if (response.status === 200) {
        setRecapData(response.data || []);
      } else {
        setRecapData([]);
      }
    } catch (error) {
      console.log("Error fetching timesheet:", error);
      setRecapData([]);
    } finally {
      setLoading(false);
    }
  };
  const fetchptodata = async ({ start_date, end_date, status } = {}) => {
    try {
      setLoading(true);

      const startDate = start_date || dateRange.startDate.format("YYYY-MM-DD");
      const endDate = end_date || dateRange.endDate.format("YYYY-MM-DD");

      let params = {};
      // console.log(status)
      // // ✅ If status is NOT "Pending", include dates
      // if (status !== "Pending"&&selected!=='Pending') {
      //   params.start_date = startDate;
      //   params.end_date = endDate;
      // }

      // ✅ If status or selected filter is applied, include status
      if (status || selected !== "All") {
        params.status = status || selected;
      }

      const response = await api.get(`/v1/${practiseid}/pto/requests`, {
        params,
      });

      if (response.status === 200) {
        setPtoReq(response.data || []);
      } else {
        setPtoReq([]);
      }
    } catch (error) {
      console.log("Error fetching timesheet:", error);
      setPtoReq([]);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (type === 0) {
      fetchtimesheetdata();
    }
  }, [isNewApp]);
  // 🟩 Step 2: Fetch data *after* dateRange has been set
  useEffect(() => {
    if (!dateRange?.startDate || !dateRange?.endDate) return;

    if (type === 0) {
      fetchtimesheetdata(); // Daily
    } else if (type === 1) {
      fetchrecapdata(); // Weekly recap
    } else if (type === 2) {
      fetchptodata();
    }
  }, [dateRange, type, selected]);

  const handleEdit = (id) => {
    console.log("Edit clicked:", id);
  };

  useEffect(() => {
    if (type !== 1) return;

    if (!recapData || recapData.length === 0) {
      setFilteredRecap([]);
      return;
    }

    let filtered = [...recapData];

    // search filter
    // if (searchTerm.trim() !== "") {
    //   const lower = searchTerm.toLowerCase();
    //   filtered = filtered.filter(
    //     (item) =>
    //       item.employee_name?.toLowerCase().includes(lower) ||
    //       item.employee_type?.toLowerCase().includes(lower),
    //   );
    // }
    if (searchTerm.trim() !== "") {
      const lower = searchTerm.toLowerCase();
      filtered = filtered.filter(
        (item) =>
          (item.firstname ?? "").toLowerCase().includes(lower) ||
          (item.emp_role ?? "").toLowerCase().includes(lower) || 
          (item.firstname ?? "").toLowerCase().includes(lower) ||
          (item.lastname ?? "").toLowerCase().includes(lower)
      );
    }

    // 👷 employee type filter (MISSING BEFORE)
    if (selectedemptype !== "All Employees") {
      const empType = selectedemptype.replace(" Employees", "");
      console.log(empType, "emptype");
      filtered = filtered.filter(
        (item) =>
          item.employee_type &&
          item.employee_type.toLowerCase().includes(empType.toLowerCase()),
      );
    }
    setFilteredRecap(filtered);
  }, [recapData, selected, searchTerm, type, selectedemptype]);
  // useEffect(() => {
  //   if(type!==0)return
  //   if (!timesheetData || timesheetData.length === 0) {
  //     setFilteredTimesheetData([]);
  //     return;
  //   }

  //   let filtered = [...timesheetData];

  //   // 🔍 Filter by search term (emp_name or emp_role)
  //   if (searchTerm.trim() !== "") {
  //     const lowerSearch = searchTerm.toLowerCase();
  //     filtered = filtered.filter(
  //       (item) =>
  //         item.emp_name.toLowerCase().includes(lowerSearch) ||
  //         item.emp_role.toLowerCase().includes(lowerSearch)
  //     );
  //   }

  //   // 👷 Filter by employee type
  //   if (selectedemptype !== "All Employees") {
  //     const empType = selectedemptype.replace(" Employees", ""); // normalize
  //     filtered = filtered.filter(
  //       (item) =>
  //         item.employee_type &&
  //         item.employee_type.toLowerCase().includes(empType.toLowerCase())
  //     );
  //   }

  //   setFilteredTimesheetData(filtered);
  // }, [searchTerm, selectedemptype, timesheetData]);

useEffect(() => {
  if (type !== 1) return;

  if (!recapData || recapData.length === 0) {
    setFilteredRecap([]);
    return;
  }

  let filtered = [...recapData];

  // ✅ Fix: use employee_name (matches your API response)
  if (searchTerm.trim() !== "") {
    const lower = searchTerm.toLowerCase();
    filtered = filtered.filter((item) =>
      (item.employee_name ?? "").toLowerCase().includes(lower) ||
      (item.employee_type ?? "").toLowerCase().includes(lower)
    );
  }

  if (selectedemptype !== "All Employees") {
    const empType = selectedemptype.replace(" Employees", "");
    filtered = filtered.filter(
      (item) =>
        item.employee_type &&
        item.employee_type.toLowerCase().includes(empType.toLowerCase())
    );
  }

  setFilteredRecap(filtered);
}, [recapData, selected, searchTerm, type, selectedemptype]);

 useEffect(() => {
  if (type !== 0) return;
  if (!timesheetData || timesheetData.length === 0) {
    setFilteredTimesheetData([]);
    return;
  }

  let filtered = [...timesheetData];

  // 🔴 Auto Clockout filter
  // if (selected === "Auto Clockout") {
  //   filtered = filtered.filter(
  //     (item) => item.audit_logs?.autoClockout?.toUpperCase() === "Y",
  //   );
  // }
// 🔴 Auto Clockout filter
if (selected === "Auto Clockout") {
  filtered = filtered.filter((item) => {
    const auditLogs = item.audit_logs ? JSON.parse(item.audit_logs) : {};
    return auditLogs.autoClockout?.toUpperCase() === "Y";
  });
}

  // 🔍 Search filter
  if (searchTerm.trim() !== "") {
    const lowerSearch = searchTerm.toLowerCase();
    filtered = filtered.filter(
      (item) =>
        (item.emp_name ?? "").toLowerCase().includes(lowerSearch) ||
        (item.emp_role ?? "").toLowerCase().includes(lowerSearch) || 
        (item.firstname ?? "").toLowerCase().includes(lowerSearch) ||
        (item.lastname ?? "").toLowerCase().includes(lowerSearch),
    );
  }

  // 👷 Employee type filter
  if (selectedemptype !== "All Employees") {
    const empType = selectedemptype.replace(" Employees", "");
    filtered = filtered.filter(
      (item) =>
        item.employee_type?.toLowerCase().includes(empType.toLowerCase()),
    );
  }
console.log("Filtered Timesheet Data:", filtered);
  setFilteredTimesheetData(filtered);
}, [timesheetData, selected, searchTerm, selectedemptype, type]);

  useEffect(() => {
    console.log(
      "🔁 useEffect triggered | type:",
      type,
      "| searchTerm:",
      searchTerm,
    );
    if (type !== 2) {
      console.log("⏩ Skipped: type is not 2");
      return;
    }

    if (!ptoreq || ptoreq.length === 0) {
      console.log("⚠️ No PTO requests found");
      setFilteredPtoReq([]);
      return;
    }

    console.log("📦 Initial PTO Requests:", ptoreq);

    let filtered = [...ptoreq];

    // 🔍 Search filter
    if (searchTerm.trim() !== "") {
      const lowerSearch = searchTerm.toLowerCase();

      filtered = filtered.filter((item) => {
        const name = item.emp_name?.toLowerCase() || "";
        const role = item.emp_role?.toLowerCase() || "";
        const type = item.request_type?.toLowerCase() || "";

        const match =
          name.includes(lowerSearch) ||
          role.includes(lowerSearch) ||
          type.includes(lowerSearch);

        console.log(
          `🧩 Checking: ${item.emp_name} (${item.emp_role}) — match:`,
          match,
        );

        return match;
      });
    } else {
      console.log("🔎 Empty search term — showing all items");
    }

    console.log("✅ Filtered Results:", filtered);

    setFilteredPtoReq(filtered);
  }, [type, searchTerm, ptoreq]);
  const ptoreqapprove = (x) => {};
  const timesheetstatusupdate = async ({ status, ids }) => {
    try {
      setLoading(true);
      const cleanIds = ids.filter(id => id !== null && id !== undefined);
      const response = await api.put(
        `/v1/${practiseid}/timesheets/status-update?status=${status}`,
        {
          timesheet_ids: cleanIds,
        },
      );
      if (response.status == 200) {
        setSeverity("success");
        setAlertMessage(response?.message || "Timesheet Updated Sucessfully");
        setOpen(true);
        fetchtimesheetdata();
      } else {
        setSeverity("info");
        setAlertMessage(response?.message || "Something went wrong");
        setOpen(true);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setSelectedRows([]);
      setLoading(false);
    }
  };
  const ptostatusupdate = async ({ status, id }) => {
    try {
      setApiLodings(true);
      const response = await api.put(`/v1/${practiseid}/pto/request/${id}`, {
        status: status,
        approved_by: user?.id,
      });
      if (response.status == 200) {
        setSeverity("success");
        setAlertMessage(response?.message || "Timesheet Updated Sucessfully");
        setOpen(true);
        fetchptodata();
      } else {
        setSeverity("info");
        setAlertMessage(response?.message || "Something went wrong");
        setOpen(true);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setApiLodings(false);
    }
  };
  const goToPrevWeek = () => {
    const prev = dateRange.startDate.subtract(7, "day");
    setDateRange(getWeekRange(prev));
  };

  const goToNextWeek = () => {
    const next = dateRange.startDate.add(7, "day");
    setDateRange(getWeekRange(next));
  };

  const handleOpenManualEntryModal = () => {
    setOpenManualEntryModal(true); // Open modal
  };

  const handleCloseManualEntry = () => {
    setOpenManualEntryModal(false); // Close modal
  };

  return (
    <SideNavLayout>
      <div className="px-6">
        <h1 className="text-start text-[20.4px] font-bold leading-[32px] text-[#1D2951] mb-6">
          {type === 0
            ? "Employee Timesheet"
            : type == 1
              ? "Reports"
              : "PTO Requests"}
        </h1>

        <div className="flex justify-between items-center mb-6">
          <div className="flex items-center gap-4">
            {(type === 1 || type === 2) && (
              <div
                className="cursor-pointer"
                // onClick={() => {
                //   setType(type === 2 ? 1 : 0);
                //   setSelected("All"); // ⭐ reset filter here
                // }}
                onClick={() => {
                  const goToType = type === 2 ? 1 : 0;
                  setType(goToType);
                  setSelected("All");
                  setSearchTerm("");
                  setSelectedemptype("All Employees");
                  setRecapData([]);
                  setFilteredRecap([]);

                  if (goToType === 0) {
                    const todayRange = { startDate: dayjs(), endDate: dayjs() };
                    setDateRange(todayRange);
                    fetchtimesheetdata({
                      start_date: dayjs().format("YYYY-MM-DD"),
                      end_date: dayjs().format("YYYY-MM-DD"),
                    });
                  }
                }}
              >
                {backicon}
              </div>
            )}

            <TimesheetFilterButtons
              buttons={buttons}
              selected={selected}
              onSelect={setSelected}
            />
          </div>

          <div className="flex items-center gap-4">
            {type === 1 && (
              <button
                onClick={() => {
                  setType(2);
                }}
                className="px-6 py-2 rounded-md bg-[#1D2951] text-white"
              >
                PTO Requests
              </button>
            )}
            {type === 1 && (
              <button
                onClick={() => {
                  setType(2);
                }}
                className="px-6 py-2 rounded-md bg-[#1D2951] text-white"
              >
                Submit
              </button>
            )}
            {type === 2 && (
              <div className="flex items-center border border-gray-300 rounded-[10px] overflow-hidden w-fit">
                {/* Table Button */}
                <button
                  onClick={() => setPtoView(0)}
                  className={`flex items-center gap-2 px-4 py-2 text-[13px] font-normal font-inter transition-all duration-200 focus:outline-none ${
                    ptoview === 0
                      ? "bg-[#172B4D] text-white"
                      : "bg-white text-gray-700 hover:bg-gray-100"
                  }`}
                >
                  <FontAwesomeIcon icon={faTableCells} />
                  Table
                </button>

                {/* Calendar Button */}
                {/* <button
        onClick={() => setPtoView(1)}
        className={`flex items-center gap-2 px-3 py-2 text-[13px] font-normal font-inter transition-all duration-200 focus:outline-none ${
          ptoview === 1
            ? "bg-[#172B4D] text-white"
            : "bg-white text-gray-700 hover:bg-gray-100"
        }`}
      >
        <FontAwesomeIcon icon={faCalendarDays} />
        Calendar
      </button> */}
              </div>
            )}

      
      {/* Create New Entry Button */}
      <ControlPointIcon className="m-2" onClick={handleOpenManualEntryModal} titleAccess="Create Manual Entry"/>

        {/* Conditionally render the ManualEntry modal */}
        {openManualEntryModal && (
          <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
            <div className="relative w-full max-w-md bg-white rounded-lg shadow-lg">
              <div className="">
                <div className="bg-[#E179545E] p-2 py-3">
                  <div className="w-full flex items-center justify-between px-2">
                    <span className="ml-2 font-semibold text-[#1D2951] text-base">
                       Manual Entry
                    </span>
                    <button 
                      className="text-[#1D2951] hover:text-gray-700 text-xl leading-none mr-1" 
                      onClick={handleCloseManualEntry}
                    >
                      ✕
                    </button>
                  </div>
                </div>
                
                <ManualEntry 
                closeManualEntryModal={handleCloseManualEntry} 
                fetchtimesheetdata={fetchtimesheetdata} start_date={dateRange.startDate.format("YYYY-MM-DD")}
                /> {/* Pass close function */}
              </div>
            </div>
          </div>
        )}


            {type === 0 && (
              <button
                // onClick={() => {
                //   setType(1);
                //   setSelected("All");
                //   setDateRange(getLastTwoWeeksRange());
                // }}
                onClick={() => {
                  const range = getLastTwoWeeksRange();
                  setType(1);
                  setSelected("All");
                  setSearchTerm("");
                  setSelectedemptype("All Employees");
                  setTimesheetData([]);
                  setFilteredTimesheetData([]);
                  setDateRange(range);
                  fetchrecapdata({
                    start_date: range.startDate.format("YYYY-MM-DD"),
                    end_date: range.endDate.format("YYYY-MM-DD"),
                  });
                }}
                className="px-6 py-2 rounded-md bg-[#1D2951] text-white"
              >
                Reports
              </button>
            )}
            {type === 0 && (
              <div onClick={() => setShowFilterModal(true)} className="h-[40px] w-[40px] flex items-center justify-center bg-white border-2 border-[#E5E7EB] rounded-md cursor-pointer">
                {filterlinkicon}
              </div>
            )}
          </div>
        </div>

        <TimesheetSearchBar
          searchTerm={searchTerm}
          type={type}
          setSearchTerm={setSearchTerm}
          setDateRange={setDateRange}
          dateRange={dateRange}
        />
        {/* {(type!==0&&type !== 2) && <TimesheetEmployeeTypeButtons data={type==0?timesheetData:type==1?recapData:[]} selectedemptype={selectedemptype}  setSelectedemptype={setSelectedemptype}/>} */}
        {type == 0 ? (
          <div>
            {selectedRows.length > 0 && (
              <div className="flex justify-end ">
                <button
                  onClick={() =>
                    timesheetstatusupdate({
                      status: "Submitted",
                      ids: selectedRows,
                    })
                  }
                  className="px-3 py-2 my-1 rounded-md bg-[#1D2951] text-white hover:bg-[#27356e] transition-colors"
                >
                  Submit Timesheet
                </button>
              </div>
            )}
          </div>
        ) : (
          <></>
        )}
        {type === 0 ? (
          <TimesheetTable
            data={filteredTimesheetData}
            isNewApp={isNewApp}
            onEdit={handleEdit}
            setIsNewApp={setIsNewApp}
            onDelete={timesheetstatusupdate}
            fetchtimesheetdata={fetchtimesheetdata}
            loading={loading}
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
            selected={selected}
            start_date={dateRange.startDate.format("YYYY-MM-DD")}
          />
        ) : type == 1 ? (
          <RecapTable
            key={filteredRecap.length + selectedemptype + searchTerm}
            data={filteredRecap}
            dateRange={dateRange}
            loading={loading}
            searchTerm={searchTerm}
          />
        ) : (
          <div className="space-y-4 mt-4">
            {ptoview === 0 ? (
              <PTORequestsTable
                key={`${loading}-${ptoreq.length}-${searchTerm}-${JSON.stringify(ptoreq.map((p) => p.id))}`}
                loading={loading}
                data={filteredptoreq}
                ptostatusupdate={ptostatusupdate}
                onApprove={(row) => ptoreqapprove(row, "a")}
                onReject={(row) => ptoreqapprove(row, "b")}
              />
            ) : (
              <PTOCalendarPro
                key={`${loading}-${ptoreq.length}-${searchTerm}-${JSON.stringify(ptoreq.map((p) => p.id))}`}
                data={filteredptoreq}
              />
            )}
          </div>
        )}
      </div>
      <ToastMessage
        message={alertmessage}
        severity={severity}
        open={open}
        handleClose={handlealert}
      />
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
          backgroundColor: "rgba(0, 0, 0, 0.7)", // reduced opacity (default is 0.5)
        }}
        open={loading || apiloadings}
      >
        <CircularProgress color="inherit" />
      </Backdrop>


{showFilterModal && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
    <div className="bg-white rounded-xl shadow-xl w-[500px] max-h-[80vh] flex flex-col">
      {/* Header */}
      <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200">
        <h2 className="text-base font-semibold text-[#1D2951]">Filter by Employee</h2>
        <button
          onClick={() => setShowFilterModal(false)}
          className="text-gray-500 hover:text-gray-700 text-xl leading-none"
        >
          ✕
        </button>
      </div>

      {/* Select All / Clear */}
      {/* <div className="flex gap-2 px-5 py-3 border-b border-gray-100">
        <button
          onClick={() => setSelectedEmployees([])}
          className="text-xs px-3 py-1 rounded-full bg-[#1D2951] text-white hover:opacity-90"
        >
          All
        </button>
        <button
          onClick={() => {
            const allNames = [...new Set(timesheetData.map((d) => d.emp_name).filter(Boolean))];
            setSelectedEmployees(allNames);
          }}
          className="text-xs px-3 py-1 rounded-full border border-gray-300 text-gray-600 hover:bg-gray-100"
        >
          Select All
        </button>
        <button
          onClick={() => setSelectedEmployees([])}
          className="text-xs px-3 py-1 rounded-full border border-gray-300 text-gray-600 hover:bg-gray-100"
        >
          Clear
        </button>
      </div> */}

      {/* Employee Buttons */}
<div className="overflow-y-auto px-4 py-3 flex flex-wrap gap-2">
  {[
    ...new Set(
      timesheetData
        .map((d) => `${d.firstname || ""} ${d.lastname || ""}`.trim())
        .filter(Boolean)
    ),
  ].map((name) => {
    const isSelected = selectedEmployees.includes(name);

    return (
      <button
        key={name}
        onClick={() => {
          setSelectedEmployees((prev) =>
            prev.includes(name)
              ? prev.filter((n) => n !== name)
              : [...prev, name]
          );
        }}
        className={`px-3 py-1.5 rounded-full text-sm border transition-colors ${
          isSelected
            ? "bg-[#50869A] text-white border-[#50869A]"
            : "bg-white text-gray-700 border-gray-300 hover:bg-gray-100"
        }`}
      >
        {name}
      </button>
    );
  })}
</div>

      {/* Footer */}
      <div className="px-5 py-3 border-t border-gray-200 flex justify-end gap-2">
        <button
          onClick={() => {
            setSelectedEmployees([]);
            setShowFilterModal(false);
          }}
          className="px-4 py-2 text-sm rounded-md border border-gray-300 text-gray-600 hover:bg-gray-100"
        >
          Reset
        </button>
        <button
          onClick={() => setShowFilterModal(false)}
          className="px-4 py-2 text-sm rounded-md bg-[#1D2951] text-white hover:opacity-90"
        >
          Apply
        </button>
      </div>
    </div>
  </div>
)}

    </SideNavLayout>
  );
};

export default EmployeeTimesheets;
